<template>
  <div v-if="currentMedia">
    <PrevNextBar
      :title="playlist.playlist_name"
      @prev="returnToPlaylist()"
      :prev-button-label="$t('GENERAL.LINK.NAVIGATE_BACK')"
      :hide-next-button="true"
    />
    <div class="img-container">
      <div class="d-flex flex-wrap container">
        <StudioPlaylistMediaDetails
          :sourceTitle="$t('PRODUCTS.LABELS.IN_THIS_PLAYLIST')"
          :media="currentMedia"
          :playlist="playlist"
          class="playlist__media-details"
          @onPlaylistMediaRouteChanged="loadData"
          :sortOrder="sortOrder.DESC"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import LegalWaiverModal from '@/web/components/shop/LegalWaiverModal';
import StudioPlaylistMediaDetails from '@/web/components/products/StudioPlaylistMediaDetails';
import PrevNextBar from '@/web/components/products/PrevNextBar';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import SortOrder from '@/core/typings/enums/SortOrder';

export default Vue.extend({
  name: 'StudioPlaylistMedia',
  mixins: [RefreshData],
  components: {
    StudioPlaylistMediaDetails,
    PrevNextBar,
  },
  data() {
    return {
      currentMedia: null,
      playlist: {},
    };
  },
  computed: {
    ...mapGetters({
      productMedia: 'product/productMedia',
      product: 'product/product',
    }),
    mediaId() {
      return this.$route.params.media_id;
    },
    sortOrder() {
      return SortOrder;
    },
  },
  methods: {
    async loadData() {
      const waiver = await this.$store.dispatch('studio/getWaiverToBeSigned', {
        studioURL: getStudioURL(this.$route),
      });
      if (waiver.id) {
        this.$modal.show(
          LegalWaiverModal,
          { showCloseButton: false, waiver },
          { clickToClose: false, classes: 'vm--inline-modal' }
        );
      }
      // do not change != to !== because it may not work
      if (!this.product || this.product.id != this.$route.params.product_id) {
        const studioURL = getStudioURL(this.$route);
        const productId = this.$route.params.product_id;
        this.$store.dispatch('product/getProductDetail', {
          studioURL,
          productId,
        });
      }
      const payload = {
        studioURL: getStudioURL(this.$route),
        productId: this.$route.params.product_id,
        playlistId: this.$route.params.playlist_id,
        mediaId: this.mediaId,
      };
      try {
        await Promise.all([
          (this.currentMedia = await this.$store.dispatch(
            'product/getProductPlaylistMediaDetail',
            payload
          )),
          (this.playlist = await this.$store.dispatch(
            'product/getStudentPlaylist',
            {
              studioURL: getStudioURL(this.$route),
              productId: this.$route.params.product_id,
              playlistId: this.$route.params.playlist_id,
            }
          )),
        ]);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('STUDIO.NOTIFICATIONS.LOAD_PRODUCT_MEDIA_ERROR'),
          text: `Error: ${error}`,
          duration: -1, // stay ON
        });
      }
    },
    returnToPlaylist() {
      return this.$router.push({
        name: 'studio-playlist',
        params: {
          product_id: this.$route.params.product_id,
          playlist_id: this.$route.params.playlist_id,
        },
      });
    },
  },
  mounted() {
    this.loadData();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.img-container {
  @include media-breakpoint-down(sm) {
    margin-left: -1rem;
    margin-right: -1rem;
  }
}

.playlist__media-details {
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 3em;
  margin-bottom: 3em;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
    margin-top: 0;
  }
}
</style>
